import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from '../queries/getUsersOwnTractors';

interface IPatchUserOwnTractorViewsByIdParams {
  productId: string;
  reqBody: {
    views: number;
  };
}

export const patchUserOwnTractorViewsById = ({
  productId,
  reqBody,
}: IPatchUserOwnTractorViewsByIdParams): Promise<void> => {
  return customAxios.patch(`${usersOwnTractorsApiUrl}/${productId}`, reqBody);
};
